import { Alert, AlertTitle, Collapse, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const FormAlert = ({ severity = "error", title, message, onClose, sx }) => (
  <Collapse in={!!message} unmountOnExit>
    <Alert
      variant="filled"
      severity={severity}
      action={
        onClose && (
          <IconButton aria-label="close" color="inherit" size="small" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        )
      }
      sx={{ borderRadius: 2, mb: 2, fontSize: '0.95rem', ...sx }}
    >
      {title && <AlertTitle sx={{ fontWeight: 600 }}>{title}</AlertTitle>}
      {message}
    </Alert>
  </Collapse>
);

export default FormAlert;
